<template>
  <base-layout>
    <h1 slot="header">
      {{ `app.pages.subscription_types` | trans }}
    </h1>
    <v-app id="vuetify-app">
      <v-container fluid>
        <v-layout row wrap align-center>
          <v-flex xs12 d-flex>
            <subscription-type-form
                method="PATCH"
                :model="model"
                @close="model = null"
            ></subscription-type-form>
          </v-flex>
        </v-layout>
        <v-layout row wrap align-start>
          <v-flex xs12 sm12 md12 d-flex>
            <resource-table ref="table" :endpoint="routes.subscription_types" :headers="headers"
                            :filters="filters">
              <template #content="{item}">
                <tr>
                  <td>
                    {{ item.id }}
                  </td>
                  <td>
                    {{ item.name }}
                  </td>
                  <td>
                    {{ item.duration }}
                  </td>
                  <td>
                    {{ item.extra_duration }}
                  <td>
                    {{ item.price }}
                  </td>
                  <td>
                    {{ item.role_to_assign }}
                  </td>
                  <td class="justify-end layout px-0 pr-4">
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn
                            v-on="on"
                            flat
                            icon
                            color="green"
                            class="mr-0 ml-0"
                            @click="editItem(item)">
                          <v-icon small>edit</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ 'app.edit' | trans }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </resource-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-app>
  </base-layout>
</template>
<script>

import {trans} from "../../../app";

export default {
  props: {
    'routes': Object,
  },
  data: () => ({
    headers: [
      {
        text: trans('app.id'), align: 'left', value: 'id', sortable: true,
      },
      {
        text: trans('app.name'), align: 'left', value: 'name', sortable: true,
      },
      {
        text: trans('app.duration'), align: 'left', value: 'duration', sortable: true,
      },
      {
        text: trans('app.extra_duration'), align: 'left', value: 'extra_duration', sortable: true,
      },
      {
        text: trans('app.price'), align: 'left', value: 'price', sortable: true,
      },
      {
        text: trans('app.role_to_assign'), align: 'left', value: 'role_to_assign', sortable: true,
      },
      {
        text: '', align: 'center', value: '', sortable: false,
      },
    ],
    filters: {},
    model: null,
  }),
  methods: {
    editItem(item) {
      this.model = {...item};
    },
  },
  mounted() {
    this.$root.$on('stored', this.$refs.table.fetchData);
  },
}
</script>
